/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateMessageByChatId = /* GraphQL */ `
  subscription OnCreateMessageByChatId($chat_id: String!) {
    OnCreateMessageByChatId(chat_id: $chat_id) {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      chat_id
      content
      image_url
      createdAt
      expiration_time
      updatedAt
    }
  }
`;
export const onUpdateAccountById = /* GraphQL */ `
  subscription OnUpdateAccountById($id: ID!) {
    onUpdateAccountById(id: $id) {
      id
      role
      interests
      nikucoins
      deleted_at
      name
      last_name
      availability
      email
      current_session
      notification_token
      favorites_shops
      sexo
      pending_chats
      zone
      delivery_zones
      birthday
      phone_number
      createdAt
      zip_codes
      autoassign
      delivery_city
      delivery_transport
      register_approved
      delivery_docs
      favorites {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      sended_reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      user_addresses {
        items {
          id
          active
          tag
          zip_codes
          createdAt
          updatedAt
        }
        nextToken
      }
      shops {
        items {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        nextToken
      }
      customer_orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deliveryman_orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deliveryman_collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      payments_vehicle {
        items {
          id
          method_pay
          date
          pay
          status
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          zone_name
          active
          deliverymen_inZone
          zone_state
          createdAt
          updatedAt
        }
        nextToken
      }
      messages {
        items {
          id
          chat_id
          content
          image_url
          createdAt
          expiration_time
          updatedAt
        }
        nextToken
      }
      chatsUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          mark
          model
          type_vehicle
          active
          status
          niv
          temporal
          price
          createdAt
          updatedAt
        }
        nextToken
      }
      categoryUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      campaign {
        items {
          id
          type
          repeat
          repeat_time
          start_campaign
          end_campaign
          title
          description
          gender
          start_age
          end_age
          zone_list
          scope
          clicks
          shopping
          status
          url_image
          interest
          subcategory
          extra_notification
          offer_type
          start_hour
          end_hour
          createdAt
          sort_attribute
          updatedAt
        }
        nextToken
      }
      delivery_inprocess
      openPay_id
      url_photoProfile
      rfc
      updatedAt
    }
  }
`;
export const onAddedaProducttoOrder = /* GraphQL */ `
  subscription OnAddedaProducttoOrder($order_id: ID!) {
    onAddedaProducttoOrder(order_id: $order_id) {
      id
      quantity
      comments
      url_audio
      url_image
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      product_id {
        id
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        orders {
          nextToken
        }
        favorites {
          nextToken
        }
        product_name
        description
        url_image
        tags
        price
        offerprice
        netcontent
        status
        product_type
        own_deliveryMan
        keywords
        additional_features
        mature
        subtag
        aisle
        limit_ticket
        expiry_ticket
        createdAt
        updatedAt
      }
      price
      additional_features
      quote_state
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateOrderByID = /* GraphQL */ `
  subscription OnUpdateOrderByID($id: ID!) {
    onUpdateOrderByID(id: $id) {
      id
      customer_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      status
      level
      discount
      percentage
      final_total
      products {
        items {
          id
          quantity
          comments
          url_audio
          url_image
          price
          additional_features
          quote_state
          createdAt
          updatedAt
        }
        nextToken
      }
      method_pay
      payment_id
      address
      orderDetails
      propina
      com_shop
      com_customer
      total
      order_type
      order_case
      reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      delivery_man_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      shop_idToSort
      bill_id {
        id
        order_id {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        description
        total
        status
        createdAt
        updatedAt
      }
      phase
      collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      require_bill
      require_service
      shop_comments
      discount_array {
        id
        value
        for_use
        used
        percentage_id {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        orders {
          nextToken
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        createdAt
        updatedAt
      }
      updatedAt
      canceled
      history
      tracking_coordinates
      nc
      prep_time
      shipping_fees
      vehicle
      createdAt
    }
  }
`;
export const onUpdateOrderByStatus = /* GraphQL */ `
  subscription OnUpdateOrderByStatus($status: String!) {
    onUpdateOrderByStatus(status: $status) {
      id
      customer_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      status
      level
      discount
      percentage
      final_total
      products {
        items {
          id
          quantity
          comments
          url_audio
          url_image
          price
          additional_features
          quote_state
          createdAt
          updatedAt
        }
        nextToken
      }
      method_pay
      payment_id
      address
      orderDetails
      propina
      com_shop
      com_customer
      total
      order_type
      order_case
      reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      delivery_man_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      shop_idToSort
      bill_id {
        id
        order_id {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        description
        total
        status
        createdAt
        updatedAt
      }
      phase
      collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      require_bill
      require_service
      shop_comments
      discount_array {
        id
        value
        for_use
        used
        percentage_id {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        orders {
          nextToken
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        createdAt
        updatedAt
      }
      updatedAt
      canceled
      history
      tracking_coordinates
      nc
      prep_time
      shipping_fees
      vehicle
      createdAt
    }
  }
`;
export const onUpdateOrderByState = /* GraphQL */ `
  subscription OnUpdateOrderByState($status: String!) {
    onUpdateOrderByState(status: $status) {
      id
      customer_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      status
      level
      discount
      percentage
      final_total
      products {
        items {
          id
          quantity
          comments
          url_audio
          url_image
          price
          additional_features
          quote_state
          createdAt
          updatedAt
        }
        nextToken
      }
      method_pay
      payment_id
      address
      orderDetails
      propina
      com_shop
      com_customer
      total
      order_type
      order_case
      reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      delivery_man_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      shop_idToSort
      bill_id {
        id
        order_id {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        description
        total
        status
        createdAt
        updatedAt
      }
      phase
      collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      require_bill
      require_service
      shop_comments
      discount_array {
        id
        value
        for_use
        used
        percentage_id {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        orders {
          nextToken
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        createdAt
        updatedAt
      }
      updatedAt
      canceled
      history
      tracking_coordinates
      nc
      prep_time
      shipping_fees
      vehicle
      createdAt
    }
  }
`;
export const onUpdateOrderByShopID = /* GraphQL */ `
  subscription OnUpdateOrderByShopID($shop_idToSort: String!) {
    onUpdateOrderByShopID(shop_idToSort: $shop_idToSort) {
      id
      customer_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      status
      level
      discount
      percentage
      final_total
      products {
        items {
          id
          quantity
          comments
          url_audio
          url_image
          price
          additional_features
          quote_state
          createdAt
          updatedAt
        }
        nextToken
      }
      method_pay
      payment_id
      address
      orderDetails
      propina
      com_shop
      com_customer
      total
      order_type
      order_case
      reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      delivery_man_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      shop_idToSort
      bill_id {
        id
        order_id {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        description
        total
        status
        createdAt
        updatedAt
      }
      phase
      collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      require_bill
      require_service
      shop_comments
      discount_array {
        id
        value
        for_use
        used
        percentage_id {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        orders {
          nextToken
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        createdAt
        updatedAt
      }
      updatedAt
      canceled
      history
      tracking_coordinates
      nc
      prep_time
      shipping_fees
      vehicle
      createdAt
    }
  }
`;
export const onCreatePercentage = /* GraphQL */ `
  subscription OnCreatePercentage {
    onCreatePercentage {
      id
      value
      array_ofDiscount
      shops {
        items {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        nextToken
      }
      discounts {
        items {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePercentage = /* GraphQL */ `
  subscription OnUpdatePercentage {
    onUpdatePercentage {
      id
      value
      array_ofDiscount
      shops {
        items {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        nextToken
      }
      discounts {
        items {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePercentage = /* GraphQL */ `
  subscription OnDeletePercentage {
    onDeletePercentage {
      id
      value
      array_ofDiscount
      shops {
        items {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        nextToken
      }
      discounts {
        items {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateDiscount = /* GraphQL */ `
  subscription OnCreateDiscount {
    onCreateDiscount {
      id
      value
      for_use
      used
      percentage_id {
        id
        value
        array_ofDiscount
        shops {
          nextToken
        }
        discounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateDiscount = /* GraphQL */ `
  subscription OnUpdateDiscount {
    onUpdateDiscount {
      id
      value
      for_use
      used
      percentage_id {
        id
        value
        array_ofDiscount
        shops {
          nextToken
        }
        discounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteDiscount = /* GraphQL */ `
  subscription OnDeleteDiscount {
    onDeleteDiscount {
      id
      value
      for_use
      used
      percentage_id {
        id
        value
        array_ofDiscount
        shops {
          nextToken
        }
        discounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateFavorite = /* GraphQL */ `
  subscription OnCreateFavorite {
    onCreateFavorite {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      product_id {
        id
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        orders {
          nextToken
        }
        favorites {
          nextToken
        }
        product_name
        description
        url_image
        tags
        price
        offerprice
        netcontent
        status
        product_type
        own_deliveryMan
        keywords
        additional_features
        mature
        subtag
        aisle
        limit_ticket
        expiry_ticket
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateFavorite = /* GraphQL */ `
  subscription OnUpdateFavorite {
    onUpdateFavorite {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      product_id {
        id
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        orders {
          nextToken
        }
        favorites {
          nextToken
        }
        product_name
        description
        url_image
        tags
        price
        offerprice
        netcontent
        status
        product_type
        own_deliveryMan
        keywords
        additional_features
        mature
        subtag
        aisle
        limit_ticket
        expiry_ticket
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteFavorite = /* GraphQL */ `
  subscription OnDeleteFavorite {
    onDeleteFavorite {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      product_id {
        id
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        orders {
          nextToken
        }
        favorites {
          nextToken
        }
        product_name
        description
        url_image
        tags
        price
        offerprice
        netcontent
        status
        product_type
        own_deliveryMan
        keywords
        additional_features
        mature
        subtag
        aisle
        limit_ticket
        expiry_ticket
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateReview = /* GraphQL */ `
  subscription OnCreateReview {
    onCreateReview {
      id
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      evaluator_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      reviewEvaluated_idId
      note
      comment
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateReview = /* GraphQL */ `
  subscription OnUpdateReview {
    onUpdateReview {
      id
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      evaluator_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      reviewEvaluated_idId
      note
      comment
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteReview = /* GraphQL */ `
  subscription OnDeleteReview {
    onDeleteReview {
      id
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      evaluator_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      reviewEvaluated_idId
      note
      comment
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCategory = /* GraphQL */ `
  subscription OnCreateCategory {
    onCreateCategory {
      id
      category_name
      tags
      subcategories
      category_user {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      category_shop {
        items {
          id
          subcategory
          aisles
          createdAt
          updatedAt
        }
        nextToken
      }
      campaigns {
        items {
          id
          type
          repeat
          repeat_time
          start_campaign
          end_campaign
          title
          description
          gender
          start_age
          end_age
          zone_list
          scope
          clicks
          shopping
          status
          url_image
          interest
          subcategory
          extra_notification
          offer_type
          start_hour
          end_hour
          createdAt
          sort_attribute
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCategory = /* GraphQL */ `
  subscription OnUpdateCategory {
    onUpdateCategory {
      id
      category_name
      tags
      subcategories
      category_user {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      category_shop {
        items {
          id
          subcategory
          aisles
          createdAt
          updatedAt
        }
        nextToken
      }
      campaigns {
        items {
          id
          type
          repeat
          repeat_time
          start_campaign
          end_campaign
          title
          description
          gender
          start_age
          end_age
          zone_list
          scope
          clicks
          shopping
          status
          url_image
          interest
          subcategory
          extra_notification
          offer_type
          start_hour
          end_hour
          createdAt
          sort_attribute
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCategory = /* GraphQL */ `
  subscription OnDeleteCategory {
    onDeleteCategory {
      id
      category_name
      tags
      subcategories
      category_user {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      category_shop {
        items {
          id
          subcategory
          aisles
          createdAt
          updatedAt
        }
        nextToken
      }
      campaigns {
        items {
          id
          type
          repeat
          repeat_time
          start_campaign
          end_campaign
          title
          description
          gender
          start_age
          end_age
          zone_list
          scope
          clicks
          shopping
          status
          url_image
          interest
          subcategory
          extra_notification
          offer_type
          start_hour
          end_hour
          createdAt
          sort_attribute
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCategoryUser = /* GraphQL */ `
  subscription OnCreateCategoryUser {
    onCreateCategoryUser {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      category_id {
        id
        category_name
        tags
        subcategories
        category_user {
          nextToken
        }
        category_shop {
          nextToken
        }
        campaigns {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCategoryUser = /* GraphQL */ `
  subscription OnUpdateCategoryUser {
    onUpdateCategoryUser {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      category_id {
        id
        category_name
        tags
        subcategories
        category_user {
          nextToken
        }
        category_shop {
          nextToken
        }
        campaigns {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCategoryUser = /* GraphQL */ `
  subscription OnDeleteCategoryUser {
    onDeleteCategoryUser {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      category_id {
        id
        category_name
        tags
        subcategories
        category_user {
          nextToken
        }
        category_shop {
          nextToken
        }
        campaigns {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCategoryShop = /* GraphQL */ `
  subscription OnCreateCategoryShop {
    onCreateCategoryShop {
      id
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      category_id {
        id
        category_name
        tags
        subcategories
        category_user {
          nextToken
        }
        category_shop {
          nextToken
        }
        campaigns {
          nextToken
        }
        createdAt
        updatedAt
      }
      subcategory
      aisles
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCategoryShop = /* GraphQL */ `
  subscription OnUpdateCategoryShop {
    onUpdateCategoryShop {
      id
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      category_id {
        id
        category_name
        tags
        subcategories
        category_user {
          nextToken
        }
        category_shop {
          nextToken
        }
        campaigns {
          nextToken
        }
        createdAt
        updatedAt
      }
      subcategory
      aisles
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCategoryShop = /* GraphQL */ `
  subscription OnDeleteCategoryShop {
    onDeleteCategoryShop {
      id
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      category_id {
        id
        category_name
        tags
        subcategories
        category_user {
          nextToken
        }
        category_shop {
          nextToken
        }
        campaigns {
          nextToken
        }
        createdAt
        updatedAt
      }
      subcategory
      aisles
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAddress = /* GraphQL */ `
  subscription OnCreateAddress {
    onCreateAddress {
      id
      country
      city
      street
      outdoor_number
      interior_number
      town
      postal_code
      latitude
      longitude
      user_addresses {
        items {
          id
          active
          tag
          zip_codes
          createdAt
          updatedAt
        }
        nextToken
      }
      zip_codes
      formatted_address
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAddress = /* GraphQL */ `
  subscription OnUpdateAddress {
    onUpdateAddress {
      id
      country
      city
      street
      outdoor_number
      interior_number
      town
      postal_code
      latitude
      longitude
      user_addresses {
        items {
          id
          active
          tag
          zip_codes
          createdAt
          updatedAt
        }
        nextToken
      }
      zip_codes
      formatted_address
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAddress = /* GraphQL */ `
  subscription OnDeleteAddress {
    onDeleteAddress {
      id
      country
      city
      street
      outdoor_number
      interior_number
      town
      postal_code
      latitude
      longitude
      user_addresses {
        items {
          id
          active
          tag
          zip_codes
          createdAt
          updatedAt
        }
        nextToken
      }
      zip_codes
      formatted_address
      createdAt
      updatedAt
    }
  }
`;
export const onCreateUserAddress = /* GraphQL */ `
  subscription OnCreateUserAddress {
    onCreateUserAddress {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      address_id {
        id
        country
        city
        street
        outdoor_number
        interior_number
        town
        postal_code
        latitude
        longitude
        user_addresses {
          nextToken
        }
        zip_codes
        formatted_address
        createdAt
        updatedAt
      }
      active
      tag
      zip_codes
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateUserAddress = /* GraphQL */ `
  subscription OnUpdateUserAddress {
    onUpdateUserAddress {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      address_id {
        id
        country
        city
        street
        outdoor_number
        interior_number
        town
        postal_code
        latitude
        longitude
        user_addresses {
          nextToken
        }
        zip_codes
        formatted_address
        createdAt
        updatedAt
      }
      active
      tag
      zip_codes
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteUserAddress = /* GraphQL */ `
  subscription OnDeleteUserAddress {
    onDeleteUserAddress {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      address_id {
        id
        country
        city
        street
        outdoor_number
        interior_number
        town
        postal_code
        latitude
        longitude
        user_addresses {
          nextToken
        }
        zip_codes
        formatted_address
        createdAt
        updatedAt
      }
      active
      tag
      zip_codes
      createdAt
      updatedAt
    }
  }
`;
export const onCreateTariff = /* GraphQL */ `
  subscription OnCreateTariff {
    onCreateTariff {
      id
      name
      description
      amount
      status
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTariff = /* GraphQL */ `
  subscription OnUpdateTariff {
    onUpdateTariff {
      id
      name
      description
      amount
      status
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTariff = /* GraphQL */ `
  subscription OnDeleteTariff {
    onDeleteTariff {
      id
      name
      description
      amount
      status
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePublicity = /* GraphQL */ `
  subscription OnCreatePublicity {
    onCreatePublicity {
      id
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      url_image
      publicity_name
      status
      deleted_at
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePublicity = /* GraphQL */ `
  subscription OnUpdatePublicity {
    onUpdatePublicity {
      id
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      url_image
      publicity_name
      status
      deleted_at
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePublicity = /* GraphQL */ `
  subscription OnDeletePublicity {
    onDeletePublicity {
      id
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      url_image
      publicity_name
      status
      deleted_at
      createdAt
      updatedAt
    }
  }
`;
export const onCreateShop = /* GraphQL */ `
  subscription OnCreateShop {
    onCreateShop {
      id
      shop_name
      business_name
      products {
        items {
          id
          product_name
          description
          url_image
          tags
          price
          offerprice
          netcontent
          status
          product_type
          own_deliveryMan
          keywords
          additional_features
          mature
          subtag
          aisle
          limit_ticket
          expiry_ticket
          createdAt
          updatedAt
        }
        nextToken
      }
      category
      categoryId
      description
      availability
      status
      schedule
      phone_number
      createdAt
      url_image
      url_shopcover
      url_pdf
      price
      publicities {
        items {
          id
          url_image
          publicity_name
          status
          deleted_at
          createdAt
          updatedAt
        }
        nextToken
      }
      orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deleted_at
      seller_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      favorites {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      address_shop
      address_coords
      city
      country
      postal_code
      category_shop {
        items {
          id
          subcategory
          aisles
          createdAt
          updatedAt
        }
        nextToken
      }
      percentage_traded {
        id
        value
        array_ofDiscount
        shops {
          nextToken
        }
        discounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      shop_type
      discounts {
        items {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        nextToken
      }
      discountsArray
      acceptCard
      interclb
      affiliator_id
      url_documents
      created_by_affiliator
      zone
      campaigns {
        items {
          id
          type
          repeat
          repeat_time
          start_campaign
          end_campaign
          title
          description
          gender
          start_age
          end_age
          zone_list
          scope
          clicks
          shopping
          status
          url_image
          interest
          subcategory
          extra_notification
          offer_type
          start_hour
          end_hour
          createdAt
          sort_attribute
          updatedAt
        }
        nextToken
      }
      showAddress
      paymentsHistory {
        items {
          id
          total_amount
          status
          period
          frequency
          plan
          type
          createdAt
          updatedAt
        }
        nextToken
      }
      subcategory
      rating
      method_pay
      list_fees
      updatedAt
    }
  }
`;
export const onUpdateShop = /* GraphQL */ `
  subscription OnUpdateShop {
    onUpdateShop {
      id
      shop_name
      business_name
      products {
        items {
          id
          product_name
          description
          url_image
          tags
          price
          offerprice
          netcontent
          status
          product_type
          own_deliveryMan
          keywords
          additional_features
          mature
          subtag
          aisle
          limit_ticket
          expiry_ticket
          createdAt
          updatedAt
        }
        nextToken
      }
      category
      categoryId
      description
      availability
      status
      schedule
      phone_number
      createdAt
      url_image
      url_shopcover
      url_pdf
      price
      publicities {
        items {
          id
          url_image
          publicity_name
          status
          deleted_at
          createdAt
          updatedAt
        }
        nextToken
      }
      orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deleted_at
      seller_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      favorites {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      address_shop
      address_coords
      city
      country
      postal_code
      category_shop {
        items {
          id
          subcategory
          aisles
          createdAt
          updatedAt
        }
        nextToken
      }
      percentage_traded {
        id
        value
        array_ofDiscount
        shops {
          nextToken
        }
        discounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      shop_type
      discounts {
        items {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        nextToken
      }
      discountsArray
      acceptCard
      interclb
      affiliator_id
      url_documents
      created_by_affiliator
      zone
      campaigns {
        items {
          id
          type
          repeat
          repeat_time
          start_campaign
          end_campaign
          title
          description
          gender
          start_age
          end_age
          zone_list
          scope
          clicks
          shopping
          status
          url_image
          interest
          subcategory
          extra_notification
          offer_type
          start_hour
          end_hour
          createdAt
          sort_attribute
          updatedAt
        }
        nextToken
      }
      showAddress
      paymentsHistory {
        items {
          id
          total_amount
          status
          period
          frequency
          plan
          type
          createdAt
          updatedAt
        }
        nextToken
      }
      subcategory
      rating
      method_pay
      list_fees
      updatedAt
    }
  }
`;
export const onDeleteShop = /* GraphQL */ `
  subscription OnDeleteShop {
    onDeleteShop {
      id
      shop_name
      business_name
      products {
        items {
          id
          product_name
          description
          url_image
          tags
          price
          offerprice
          netcontent
          status
          product_type
          own_deliveryMan
          keywords
          additional_features
          mature
          subtag
          aisle
          limit_ticket
          expiry_ticket
          createdAt
          updatedAt
        }
        nextToken
      }
      category
      categoryId
      description
      availability
      status
      schedule
      phone_number
      createdAt
      url_image
      url_shopcover
      url_pdf
      price
      publicities {
        items {
          id
          url_image
          publicity_name
          status
          deleted_at
          createdAt
          updatedAt
        }
        nextToken
      }
      orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deleted_at
      seller_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      favorites {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      address_shop
      address_coords
      city
      country
      postal_code
      category_shop {
        items {
          id
          subcategory
          aisles
          createdAt
          updatedAt
        }
        nextToken
      }
      percentage_traded {
        id
        value
        array_ofDiscount
        shops {
          nextToken
        }
        discounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      shop_type
      discounts {
        items {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        nextToken
      }
      discountsArray
      acceptCard
      interclb
      affiliator_id
      url_documents
      created_by_affiliator
      zone
      campaigns {
        items {
          id
          type
          repeat
          repeat_time
          start_campaign
          end_campaign
          title
          description
          gender
          start_age
          end_age
          zone_list
          scope
          clicks
          shopping
          status
          url_image
          interest
          subcategory
          extra_notification
          offer_type
          start_hour
          end_hour
          createdAt
          sort_attribute
          updatedAt
        }
        nextToken
      }
      showAddress
      paymentsHistory {
        items {
          id
          total_amount
          status
          period
          frequency
          plan
          type
          createdAt
          updatedAt
        }
        nextToken
      }
      subcategory
      rating
      method_pay
      list_fees
      updatedAt
    }
  }
`;
export const onCreateBill = /* GraphQL */ `
  subscription OnCreateBill {
    onCreateBill {
      id
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      description
      total
      status
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateBill = /* GraphQL */ `
  subscription OnUpdateBill {
    onUpdateBill {
      id
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      description
      total
      status
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteBill = /* GraphQL */ `
  subscription OnDeleteBill {
    onDeleteBill {
      id
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      description
      total
      status
      createdAt
      updatedAt
    }
  }
`;
export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct {
    onCreateProduct {
      id
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      orders {
        items {
          id
          quantity
          comments
          url_audio
          url_image
          price
          additional_features
          quote_state
          createdAt
          updatedAt
        }
        nextToken
      }
      favorites {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      product_name
      description
      url_image
      tags
      price
      offerprice
      netcontent
      status
      product_type
      own_deliveryMan
      keywords
      additional_features
      mature
      subtag
      aisle
      limit_ticket
      expiry_ticket
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct {
    onUpdateProduct {
      id
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      orders {
        items {
          id
          quantity
          comments
          url_audio
          url_image
          price
          additional_features
          quote_state
          createdAt
          updatedAt
        }
        nextToken
      }
      favorites {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      product_name
      description
      url_image
      tags
      price
      offerprice
      netcontent
      status
      product_type
      own_deliveryMan
      keywords
      additional_features
      mature
      subtag
      aisle
      limit_ticket
      expiry_ticket
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct {
    onDeleteProduct {
      id
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      orders {
        items {
          id
          quantity
          comments
          url_audio
          url_image
          price
          additional_features
          quote_state
          createdAt
          updatedAt
        }
        nextToken
      }
      favorites {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      product_name
      description
      url_image
      tags
      price
      offerprice
      netcontent
      status
      product_type
      own_deliveryMan
      keywords
      additional_features
      mature
      subtag
      aisle
      limit_ticket
      expiry_ticket
      createdAt
      updatedAt
    }
  }
`;
export const onCreateOrderProduct = /* GraphQL */ `
  subscription OnCreateOrderProduct {
    onCreateOrderProduct {
      id
      quantity
      comments
      url_audio
      url_image
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      product_id {
        id
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        orders {
          nextToken
        }
        favorites {
          nextToken
        }
        product_name
        description
        url_image
        tags
        price
        offerprice
        netcontent
        status
        product_type
        own_deliveryMan
        keywords
        additional_features
        mature
        subtag
        aisle
        limit_ticket
        expiry_ticket
        createdAt
        updatedAt
      }
      price
      additional_features
      quote_state
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateOrderProduct = /* GraphQL */ `
  subscription OnUpdateOrderProduct {
    onUpdateOrderProduct {
      id
      quantity
      comments
      url_audio
      url_image
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      product_id {
        id
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        orders {
          nextToken
        }
        favorites {
          nextToken
        }
        product_name
        description
        url_image
        tags
        price
        offerprice
        netcontent
        status
        product_type
        own_deliveryMan
        keywords
        additional_features
        mature
        subtag
        aisle
        limit_ticket
        expiry_ticket
        createdAt
        updatedAt
      }
      price
      additional_features
      quote_state
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteOrderProduct = /* GraphQL */ `
  subscription OnDeleteOrderProduct {
    onDeleteOrderProduct {
      id
      quantity
      comments
      url_audio
      url_image
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      product_id {
        id
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        orders {
          nextToken
        }
        favorites {
          nextToken
        }
        product_name
        description
        url_image
        tags
        price
        offerprice
        netcontent
        status
        product_type
        own_deliveryMan
        keywords
        additional_features
        mature
        subtag
        aisle
        limit_ticket
        expiry_ticket
        createdAt
        updatedAt
      }
      price
      additional_features
      quote_state
      createdAt
      updatedAt
    }
  }
`;
export const onCreateOrder = /* GraphQL */ `
  subscription OnCreateOrder {
    onCreateOrder {
      id
      customer_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      status
      level
      discount
      percentage
      final_total
      products {
        items {
          id
          quantity
          comments
          url_audio
          url_image
          price
          additional_features
          quote_state
          createdAt
          updatedAt
        }
        nextToken
      }
      method_pay
      payment_id
      address
      orderDetails
      propina
      com_shop
      com_customer
      total
      order_type
      order_case
      reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      delivery_man_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      shop_idToSort
      bill_id {
        id
        order_id {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        description
        total
        status
        createdAt
        updatedAt
      }
      phase
      collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      require_bill
      require_service
      shop_comments
      discount_array {
        id
        value
        for_use
        used
        percentage_id {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        orders {
          nextToken
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        createdAt
        updatedAt
      }
      updatedAt
      canceled
      history
      tracking_coordinates
      nc
      prep_time
      shipping_fees
      vehicle
      createdAt
    }
  }
`;
export const onUpdateOrder = /* GraphQL */ `
  subscription OnUpdateOrder {
    onUpdateOrder {
      id
      customer_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      status
      level
      discount
      percentage
      final_total
      products {
        items {
          id
          quantity
          comments
          url_audio
          url_image
          price
          additional_features
          quote_state
          createdAt
          updatedAt
        }
        nextToken
      }
      method_pay
      payment_id
      address
      orderDetails
      propina
      com_shop
      com_customer
      total
      order_type
      order_case
      reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      delivery_man_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      shop_idToSort
      bill_id {
        id
        order_id {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        description
        total
        status
        createdAt
        updatedAt
      }
      phase
      collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      require_bill
      require_service
      shop_comments
      discount_array {
        id
        value
        for_use
        used
        percentage_id {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        orders {
          nextToken
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        createdAt
        updatedAt
      }
      updatedAt
      canceled
      history
      tracking_coordinates
      nc
      prep_time
      shipping_fees
      vehicle
      createdAt
    }
  }
`;
export const onDeleteOrder = /* GraphQL */ `
  subscription OnDeleteOrder {
    onDeleteOrder {
      id
      customer_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      status
      level
      discount
      percentage
      final_total
      products {
        items {
          id
          quantity
          comments
          url_audio
          url_image
          price
          additional_features
          quote_state
          createdAt
          updatedAt
        }
        nextToken
      }
      method_pay
      payment_id
      address
      orderDetails
      propina
      com_shop
      com_customer
      total
      order_type
      order_case
      reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      delivery_man_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      shop_idToSort
      bill_id {
        id
        order_id {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        description
        total
        status
        createdAt
        updatedAt
      }
      phase
      collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      require_bill
      require_service
      shop_comments
      discount_array {
        id
        value
        for_use
        used
        percentage_id {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        orders {
          nextToken
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        createdAt
        updatedAt
      }
      updatedAt
      canceled
      history
      tracking_coordinates
      nc
      prep_time
      shipping_fees
      vehicle
      createdAt
    }
  }
`;
export const onCreateCollect = /* GraphQL */ `
  subscription OnCreateCollect {
    onCreateCollect {
      id
      picking_date
      come_date
      type
      origin_sign
      sign
      finished
      deliveryman_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCollect = /* GraphQL */ `
  subscription OnUpdateCollect {
    onUpdateCollect {
      id
      picking_date
      come_date
      type
      origin_sign
      sign
      finished
      deliveryman_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCollect = /* GraphQL */ `
  subscription OnDeleteCollect {
    onDeleteCollect {
      id
      picking_date
      come_date
      type
      origin_sign
      sign
      finished
      deliveryman_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      order_id {
        id
        customer_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        status
        level
        discount
        percentage
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        orderDetails
        propina
        com_shop
        com_customer
        total
        order_type
        order_case
        reviews {
          nextToken
        }
        delivery_man_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        shop_id {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        shop_idToSort
        bill_id {
          id
          description
          total
          status
          createdAt
          updatedAt
        }
        phase
        collects {
          nextToken
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        updatedAt
        canceled
        history
        tracking_coordinates
        nc
        prep_time
        shipping_fees
        vehicle
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateVehicle = /* GraphQL */ `
  subscription OnCreateVehicle {
    onCreateVehicle {
      id
      mark
      model
      type_vehicle
      active
      status
      niv
      temporal
      zone_id {
        id
        zone_name
        active
        deliverymen_inZone
        franchisse_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        bases {
          nextToken
        }
        vehicles {
          nextToken
        }
        zone_state
        createdAt
        updatedAt
      }
      delivery_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      price
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateVehicle = /* GraphQL */ `
  subscription OnUpdateVehicle {
    onUpdateVehicle {
      id
      mark
      model
      type_vehicle
      active
      status
      niv
      temporal
      zone_id {
        id
        zone_name
        active
        deliverymen_inZone
        franchisse_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        bases {
          nextToken
        }
        vehicles {
          nextToken
        }
        zone_state
        createdAt
        updatedAt
      }
      delivery_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      price
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteVehicle = /* GraphQL */ `
  subscription OnDeleteVehicle {
    onDeleteVehicle {
      id
      mark
      model
      type_vehicle
      active
      status
      niv
      temporal
      zone_id {
        id
        zone_name
        active
        deliverymen_inZone
        franchisse_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        bases {
          nextToken
        }
        vehicles {
          nextToken
        }
        zone_state
        createdAt
        updatedAt
      }
      delivery_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      price
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePaymentVehicle = /* GraphQL */ `
  subscription OnCreatePaymentVehicle {
    onCreatePaymentVehicle {
      id
      method_pay
      date
      pay
      status
      deliveryman_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePaymentVehicle = /* GraphQL */ `
  subscription OnUpdatePaymentVehicle {
    onUpdatePaymentVehicle {
      id
      method_pay
      date
      pay
      status
      deliveryman_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePaymentVehicle = /* GraphQL */ `
  subscription OnDeletePaymentVehicle {
    onDeletePaymentVehicle {
      id
      method_pay
      date
      pay
      status
      deliveryman_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateZone = /* GraphQL */ `
  subscription OnCreateZone {
    onCreateZone {
      id
      zone_name
      active
      deliverymen_inZone
      franchisse_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      bases {
        items {
          id
          description
          active
          address
          country
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          mark
          model
          type_vehicle
          active
          status
          niv
          temporal
          price
          createdAt
          updatedAt
        }
        nextToken
      }
      zone_state
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateZone = /* GraphQL */ `
  subscription OnUpdateZone {
    onUpdateZone {
      id
      zone_name
      active
      deliverymen_inZone
      franchisse_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      bases {
        items {
          id
          description
          active
          address
          country
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          mark
          model
          type_vehicle
          active
          status
          niv
          temporal
          price
          createdAt
          updatedAt
        }
        nextToken
      }
      zone_state
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteZone = /* GraphQL */ `
  subscription OnDeleteZone {
    onDeleteZone {
      id
      zone_name
      active
      deliverymen_inZone
      franchisse_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      bases {
        items {
          id
          description
          active
          address
          country
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          mark
          model
          type_vehicle
          active
          status
          niv
          temporal
          price
          createdAt
          updatedAt
        }
        nextToken
      }
      zone_state
      createdAt
      updatedAt
    }
  }
`;
export const onCreateBase = /* GraphQL */ `
  subscription OnCreateBase {
    onCreateBase {
      id
      description
      active
      address
      zone_id {
        id
        zone_name
        active
        deliverymen_inZone
        franchisse_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        bases {
          nextToken
        }
        vehicles {
          nextToken
        }
        zone_state
        createdAt
        updatedAt
      }
      country
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateBase = /* GraphQL */ `
  subscription OnUpdateBase {
    onUpdateBase {
      id
      description
      active
      address
      zone_id {
        id
        zone_name
        active
        deliverymen_inZone
        franchisse_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        bases {
          nextToken
        }
        vehicles {
          nextToken
        }
        zone_state
        createdAt
        updatedAt
      }
      country
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteBase = /* GraphQL */ `
  subscription OnDeleteBase {
    onDeleteBase {
      id
      description
      active
      address
      zone_id {
        id
        zone_name
        active
        deliverymen_inZone
        franchisse_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        bases {
          nextToken
        }
        vehicles {
          nextToken
        }
        zone_state
        createdAt
        updatedAt
      }
      country
      createdAt
      updatedAt
    }
  }
`;
export const onCreateActiveCampaigns = /* GraphQL */ `
  subscription OnCreateActiveCampaigns {
    onCreateActiveCampaigns {
      id
      type
      start_campaign
      end_campaign
      status
      url_image
      TTLCampaign
      repeat
      repeat_time
      title
      description
      gender
      start_age
      end_age
      zone_list
      interest
      sort_attribute
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateActiveCampaigns = /* GraphQL */ `
  subscription OnUpdateActiveCampaigns {
    onUpdateActiveCampaigns {
      id
      type
      start_campaign
      end_campaign
      status
      url_image
      TTLCampaign
      repeat
      repeat_time
      title
      description
      gender
      start_age
      end_age
      zone_list
      interest
      sort_attribute
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteActiveCampaigns = /* GraphQL */ `
  subscription OnDeleteActiveCampaigns {
    onDeleteActiveCampaigns {
      id
      type
      start_campaign
      end_campaign
      status
      url_image
      TTLCampaign
      repeat
      repeat_time
      title
      description
      gender
      start_age
      end_age
      zone_list
      interest
      sort_attribute
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCampaign = /* GraphQL */ `
  subscription OnCreateCampaign {
    onCreateCampaign {
      id
      type
      business_list {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      repeat
      repeat_time
      start_campaign
      end_campaign
      id_marketer {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      title
      description
      gender
      start_age
      end_age
      zone_list
      scope
      clicks
      shopping
      status
      url_image
      interest
      category_id {
        id
        category_name
        tags
        subcategories
        category_user {
          nextToken
        }
        category_shop {
          nextToken
        }
        campaigns {
          nextToken
        }
        createdAt
        updatedAt
      }
      subcategory
      extra_notification
      offer_type
      start_hour
      end_hour
      createdAt
      sort_attribute
      updatedAt
    }
  }
`;
export const onUpdateCampaign = /* GraphQL */ `
  subscription OnUpdateCampaign {
    onUpdateCampaign {
      id
      type
      business_list {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      repeat
      repeat_time
      start_campaign
      end_campaign
      id_marketer {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      title
      description
      gender
      start_age
      end_age
      zone_list
      scope
      clicks
      shopping
      status
      url_image
      interest
      category_id {
        id
        category_name
        tags
        subcategories
        category_user {
          nextToken
        }
        category_shop {
          nextToken
        }
        campaigns {
          nextToken
        }
        createdAt
        updatedAt
      }
      subcategory
      extra_notification
      offer_type
      start_hour
      end_hour
      createdAt
      sort_attribute
      updatedAt
    }
  }
`;
export const onDeleteCampaign = /* GraphQL */ `
  subscription OnDeleteCampaign {
    onDeleteCampaign {
      id
      type
      business_list {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      repeat
      repeat_time
      start_campaign
      end_campaign
      id_marketer {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      title
      description
      gender
      start_age
      end_age
      zone_list
      scope
      clicks
      shopping
      status
      url_image
      interest
      category_id {
        id
        category_name
        tags
        subcategories
        category_user {
          nextToken
        }
        category_shop {
          nextToken
        }
        campaigns {
          nextToken
        }
        createdAt
        updatedAt
      }
      subcategory
      extra_notification
      offer_type
      start_hour
      end_hour
      createdAt
      sort_attribute
      updatedAt
    }
  }
`;
export const onCreateChat = /* GraphQL */ `
  subscription OnCreateChat {
    onCreateChat {
      id
      active
      new_message
      chatsUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateChat = /* GraphQL */ `
  subscription OnUpdateChat {
    onUpdateChat {
      id
      active
      new_message
      chatsUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteChat = /* GraphQL */ `
  subscription OnDeleteChat {
    onDeleteChat {
      id
      active
      new_message
      chatsUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePaymentHistory = /* GraphQL */ `
  subscription OnCreatePaymentHistory {
    onCreatePaymentHistory {
      id
      total_amount
      status
      period
      frequency
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      plan
      type
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePaymentHistory = /* GraphQL */ `
  subscription OnUpdatePaymentHistory {
    onUpdatePaymentHistory {
      id
      total_amount
      status
      period
      frequency
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      plan
      type
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePaymentHistory = /* GraphQL */ `
  subscription OnDeletePaymentHistory {
    onDeletePaymentHistory {
      id
      total_amount
      status
      period
      frequency
      shop_id {
        id
        shop_name
        business_name
        products {
          nextToken
        }
        category
        categoryId
        description
        availability
        status
        schedule
        phone_number
        createdAt
        url_image
        url_shopcover
        url_pdf
        price
        publicities {
          nextToken
        }
        orders {
          nextToken
        }
        deleted_at
        seller_id {
          id
          role
          interests
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          notification_token
          favorites_shops
          sexo
          pending_chats
          zone
          delivery_zones
          birthday
          phone_number
          createdAt
          zip_codes
          autoassign
          delivery_city
          delivery_transport
          register_approved
          delivery_docs
          delivery_inprocess
          openPay_id
          url_photoProfile
          rfc
          updatedAt
        }
        favorites {
          nextToken
        }
        address_shop
        address_coords
        city
        country
        postal_code
        category_shop {
          nextToken
        }
        percentage_traded {
          id
          value
          array_ofDiscount
          createdAt
          updatedAt
        }
        shop_type
        discounts {
          nextToken
        }
        discountsArray
        acceptCard
        interclb
        affiliator_id
        url_documents
        created_by_affiliator
        zone
        campaigns {
          nextToken
        }
        showAddress
        paymentsHistory {
          nextToken
        }
        subcategory
        rating
        method_pay
        list_fees
        updatedAt
      }
      plan
      type
      createdAt
      updatedAt
    }
  }
`;
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage {
    onCreateMessage {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      chat_id
      content
      image_url
      createdAt
      expiration_time
      updatedAt
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage {
    onUpdateMessage {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      chat_id
      content
      image_url
      createdAt
      expiration_time
      updatedAt
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage {
    onDeleteMessage {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      chat_id
      content
      image_url
      createdAt
      expiration_time
      updatedAt
    }
  }
`;
export const onCreateChatUser = /* GraphQL */ `
  subscription OnCreateChatUser {
    onCreateChatUser {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      chat_id {
        id
        active
        new_message
        chatsUser {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateChatUser = /* GraphQL */ `
  subscription OnUpdateChatUser {
    onUpdateChatUser {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      chat_id {
        id
        active
        new_message
        chatsUser {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteChatUser = /* GraphQL */ `
  subscription OnDeleteChatUser {
    onDeleteChatUser {
      id
      user_id {
        id
        role
        interests
        nikucoins
        deleted_at
        name
        last_name
        availability
        email
        current_session
        notification_token
        favorites_shops
        sexo
        pending_chats
        zone
        delivery_zones
        birthday
        phone_number
        createdAt
        zip_codes
        autoassign
        delivery_city
        delivery_transport
        register_approved
        delivery_docs
        favorites {
          nextToken
        }
        sended_reviews {
          nextToken
        }
        user_addresses {
          nextToken
        }
        shops {
          nextToken
        }
        customer_orders {
          nextToken
        }
        deliveryman_orders {
          nextToken
        }
        deliveryman_collects {
          nextToken
        }
        payments_vehicle {
          nextToken
        }
        zones {
          nextToken
        }
        messages {
          nextToken
        }
        chatsUser {
          nextToken
        }
        vehicles {
          nextToken
        }
        categoryUser {
          nextToken
        }
        campaign {
          nextToken
        }
        delivery_inprocess
        openPay_id
        url_photoProfile
        rfc
        updatedAt
      }
      chat_id {
        id
        active
        new_message
        chatsUser {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAccount = /* GraphQL */ `
  subscription OnCreateAccount {
    onCreateAccount {
      id
      role
      interests
      nikucoins
      deleted_at
      name
      last_name
      availability
      email
      current_session
      notification_token
      favorites_shops
      sexo
      pending_chats
      zone
      delivery_zones
      birthday
      phone_number
      createdAt
      zip_codes
      autoassign
      delivery_city
      delivery_transport
      register_approved
      delivery_docs
      favorites {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      sended_reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      user_addresses {
        items {
          id
          active
          tag
          zip_codes
          createdAt
          updatedAt
        }
        nextToken
      }
      shops {
        items {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        nextToken
      }
      customer_orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deliveryman_orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deliveryman_collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      payments_vehicle {
        items {
          id
          method_pay
          date
          pay
          status
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          zone_name
          active
          deliverymen_inZone
          zone_state
          createdAt
          updatedAt
        }
        nextToken
      }
      messages {
        items {
          id
          chat_id
          content
          image_url
          createdAt
          expiration_time
          updatedAt
        }
        nextToken
      }
      chatsUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          mark
          model
          type_vehicle
          active
          status
          niv
          temporal
          price
          createdAt
          updatedAt
        }
        nextToken
      }
      categoryUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      campaign {
        items {
          id
          type
          repeat
          repeat_time
          start_campaign
          end_campaign
          title
          description
          gender
          start_age
          end_age
          zone_list
          scope
          clicks
          shopping
          status
          url_image
          interest
          subcategory
          extra_notification
          offer_type
          start_hour
          end_hour
          createdAt
          sort_attribute
          updatedAt
        }
        nextToken
      }
      delivery_inprocess
      openPay_id
      url_photoProfile
      rfc
      updatedAt
    }
  }
`;
export const onUpdateAccount = /* GraphQL */ `
  subscription OnUpdateAccount {
    onUpdateAccount {
      id
      role
      interests
      nikucoins
      deleted_at
      name
      last_name
      availability
      email
      current_session
      notification_token
      favorites_shops
      sexo
      pending_chats
      zone
      delivery_zones
      birthday
      phone_number
      createdAt
      zip_codes
      autoassign
      delivery_city
      delivery_transport
      register_approved
      delivery_docs
      favorites {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      sended_reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      user_addresses {
        items {
          id
          active
          tag
          zip_codes
          createdAt
          updatedAt
        }
        nextToken
      }
      shops {
        items {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        nextToken
      }
      customer_orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deliveryman_orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deliveryman_collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      payments_vehicle {
        items {
          id
          method_pay
          date
          pay
          status
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          zone_name
          active
          deliverymen_inZone
          zone_state
          createdAt
          updatedAt
        }
        nextToken
      }
      messages {
        items {
          id
          chat_id
          content
          image_url
          createdAt
          expiration_time
          updatedAt
        }
        nextToken
      }
      chatsUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          mark
          model
          type_vehicle
          active
          status
          niv
          temporal
          price
          createdAt
          updatedAt
        }
        nextToken
      }
      categoryUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      campaign {
        items {
          id
          type
          repeat
          repeat_time
          start_campaign
          end_campaign
          title
          description
          gender
          start_age
          end_age
          zone_list
          scope
          clicks
          shopping
          status
          url_image
          interest
          subcategory
          extra_notification
          offer_type
          start_hour
          end_hour
          createdAt
          sort_attribute
          updatedAt
        }
        nextToken
      }
      delivery_inprocess
      openPay_id
      url_photoProfile
      rfc
      updatedAt
    }
  }
`;
export const onDeleteAccount = /* GraphQL */ `
  subscription OnDeleteAccount {
    onDeleteAccount {
      id
      role
      interests
      nikucoins
      deleted_at
      name
      last_name
      availability
      email
      current_session
      notification_token
      favorites_shops
      sexo
      pending_chats
      zone
      delivery_zones
      birthday
      phone_number
      createdAt
      zip_codes
      autoassign
      delivery_city
      delivery_transport
      register_approved
      delivery_docs
      favorites {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      sended_reviews {
        items {
          id
          reviewEvaluated_idId
          note
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      user_addresses {
        items {
          id
          active
          tag
          zip_codes
          createdAt
          updatedAt
        }
        nextToken
      }
      shops {
        items {
          id
          shop_name
          business_name
          category
          categoryId
          description
          availability
          status
          schedule
          phone_number
          createdAt
          url_image
          url_shopcover
          url_pdf
          price
          deleted_at
          address_shop
          address_coords
          city
          country
          postal_code
          shop_type
          discountsArray
          acceptCard
          interclb
          affiliator_id
          url_documents
          created_by_affiliator
          zone
          showAddress
          subcategory
          rating
          method_pay
          list_fees
          updatedAt
        }
        nextToken
      }
      customer_orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deliveryman_orders {
        items {
          id
          status
          level
          discount
          percentage
          final_total
          method_pay
          payment_id
          address
          orderDetails
          propina
          com_shop
          com_customer
          total
          order_type
          order_case
          shop_idToSort
          phase
          require_bill
          require_service
          shop_comments
          updatedAt
          canceled
          history
          tracking_coordinates
          nc
          prep_time
          shipping_fees
          vehicle
          createdAt
        }
        nextToken
      }
      deliveryman_collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
          createdAt
          updatedAt
        }
        nextToken
      }
      payments_vehicle {
        items {
          id
          method_pay
          date
          pay
          status
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          zone_name
          active
          deliverymen_inZone
          zone_state
          createdAt
          updatedAt
        }
        nextToken
      }
      messages {
        items {
          id
          chat_id
          content
          image_url
          createdAt
          expiration_time
          updatedAt
        }
        nextToken
      }
      chatsUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          mark
          model
          type_vehicle
          active
          status
          niv
          temporal
          price
          createdAt
          updatedAt
        }
        nextToken
      }
      categoryUser {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
      campaign {
        items {
          id
          type
          repeat
          repeat_time
          start_campaign
          end_campaign
          title
          description
          gender
          start_age
          end_age
          zone_list
          scope
          clicks
          shopping
          status
          url_image
          interest
          subcategory
          extra_notification
          offer_type
          start_hour
          end_hour
          createdAt
          sort_attribute
          updatedAt
        }
        nextToken
      }
      delivery_inprocess
      openPay_id
      url_photoProfile
      rfc
      updatedAt
    }
  }
`;
